/** Raw same-origin fetch intentionally targets the current deployment. */
export async function fetchAppVersion(signal?: AbortSignal): Promise<string> {
  const response = await fetch("/api/app-version", {
    cache: "no-store",
    headers: { Accept: "application/json" },
    signal,
  });
  if (!response.ok || response.redirected)
    throw new Error("Version check failed");
  const body: unknown = await response.json();
  if (
    !body ||
    typeof body !== "object" ||
    !("version" in body) ||
    typeof body.version !== "string" ||
    !body.version.trim() ||
    body.version.length > 200
  ) {
    throw new Error("Version check returned an invalid version");
  }
  return body.version;
}
